export default __webpack_public_path__ + "assets/models/d6c7e172f39156f24c13e29217f61563.glb";